export enum AssociationType {
  EVENT = 'Event'
}
